import { render, staticRenderFns } from "./AccountDomains.vue?vue&type=template&id=743a1fea&"
import script from "./AccountDomains.vue?vue&type=script&lang=ts&"
export * from "./AccountDomains.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports